import React, {Component} from "react";
import Paper from "@material-ui/core/Paper";
import {clubDisplayEmail, clubWebsiteUrl} from "../Backend/clubDetails";
import {db} from "../Backend/fire";
import {Button} from "@material-ui/core";
import {SubmitButton} from "../components/Common/Buttons";
import {getMinimalRoomRecord} from "../Backend/feedbackBackendFunctions";
import {getPartnerDetails, getPositionInRoom} from "../Backend/assignmentBackendFunctions";

class Migrator extends Component {
    componentDidMount() {
        this.props.onLoad();
    }

    addDebateResultsSupport() {
        db
            .collectionGroup("FeedbacksToFill")
            .get()
            .then(feedbacksSnapshot => {
                if (feedbacksSnapshot.empty) {
                    console.log("No feedbacks");
                    return;
                }
                feedbacksSnapshot.forEach(feedbackDoc => {
                    let feedback = feedbackDoc.data();
                    let eventId = feedback.event.id;
                    let chairId = feedbackDoc.ref.parent.parent.id;
                    if (feedback.record) {
                        return;
                    }
                    db.collection("Events")
                        .doc(eventId)
                        .collection("EventData")
                        .doc("Assignments")
                        .get()
                        .then(feedbackAssignments => {
                            let chairRoom = feedbackAssignments.data().rooms.filter(x => x.Chair.some(y => y.uid === chairId))[0];
                            feedback.record = getMinimalRoomRecord(chairRoom);
                            if (!feedback.event.motion) {
                                feedback.event.motion = "";
                            }
                            if (!feedback.event.info_slide) {
                                feedback.event.info_slide = "";
                            }
                            feedback.event.requestedFeedbacks = true;
                            feedbackDoc.ref.set(feedback, {merge: true})
                                .then(_ => console.log("Success"))
                                .catch(e => {
                                    console.log("Error while processing: " + e);
                                });
                            db.collection("Events")
                                .doc(eventId)
                                .set(feedback.event, {merge: true})
                                .then(_ => console.log("Success"))
                                .catch(e => console.log("Error while processing: " + e));
                            if (!feedback.debaters || Object.keys(feedback.debaters).length === 0) {
                                return;
                            }
                            Object.keys(feedback.record).forEach(debaterId => {
                                if (debaterId && !debaterId.includes("FAKE")) {
                                    let chair = chairRoom;
                                    if (chair) {
                                        chair = chair.Chair;
                                    }
                                    if (chair) {
                                        chair = chair[0];
                                    }
                                    chair = chair || {};
                                    let userJson = {};
                                    let eventData = {
                                        time: feedback.event.time,
                                        motion: feedback.event.motion || "",
                                        info_slide: feedback.event.info_slide || "",
                                        chair_name_eng: chair.full_name_eng || "",
                                        chair_name_heb: chair.full_name_heb || "",
                                        speaker_points: 0,
                                        ...getPartnerDetails(chairRoom, debaterId),
                                        chair: chairId || "unknown_chair",
                                        position: getPositionInRoom(chairRoom, debaterId),
                                    };
                                    userJson[feedback.event.id] = eventData;
                                    db
                                        .collection("Debaters")
                                        .doc(debaterId)
                                        .collection("PersonalData")
                                        .doc("Feedbacks")
                                        .set(userJson, {merge: true})
                                        .then(_ => console.log("Success"))
                                        .catch(e => console.log("Error while processing: " + e));
                                }
                            })
                        }).catch(e => {
                        console.log("Error while processing: " + e);
                    });
                });
            })
            .catch(e => {
                console.log("Error while processing: " + e);
            });
    }


    render() {
        return (
            <Paper
                style={{
                    margin: "2% 4%",
                    padding: "2%",
                    "max-width": "750px",
                    "margin-right": "auto",
                    "margin-left": "auto"
                }}
            >
                <Button onClick={this.addDebateResultsSupport}
                        style={{margin: 10}}
                        variant="contained"
                        color="primary">
                    Add Debate Results Support
                </Button>
                {/*<Button onClick={() => addPartners()}*/}
                {/*        style={{margin: 10}}*/}
                {/*        variant="contained"*/}
                {/*        color="primary">*/}
                {/*    Add partners*/}
                {/*</Button>*/}
                <Button onClick={() => addSpeakerPoints()}
                        style={{margin: 10}}
                        variant="contained"
                        color="primary">
                    Add speaker points
                </Button>
            </Paper>
        );
    }
}

async function addPartners() {
    try {
        let debaters = await db.collection("Debaters").get();
        if (debaters.empty) {
            console.log("No feedbacks");
            return;
        }
        debaters.forEach(debaterDoc => {
            addPartnersForDebater(debaterDoc);
        });
    } catch (e) {
        console.log("Error while processing: " + e);
    }
}

async function addSpeakerPoints() {
    try {
        let debaters = await db.collection("Debaters").get();
        if (debaters.empty) {
            console.log("No feedbacks");
            return;
        }
        debaters.forEach(debaterDoc => {
            addSpeakerPointsForDebater(debaterDoc);
        });
    } catch (e) {
        console.log("Error while processing: " + e);
    }
}

async function addPartnersForDebater(debaterDoc) {
    if (debaterDoc.id === "All_Debaters") {
        console.log("Skipping All_Debaters");
        return;
    }
    let fDoc = await debaterDoc.ref.collection("PersonalData").doc("Feedbacks").get();
    let doc = fDoc.data();
    if (Object.values(doc)[0] && Object.values(doc)[0]["partner"]) {
        console.log(debaterDoc.ref.id + " already migrated");
        return;
    }
    let newDoc = {};
    for (let [id, event] of Object.entries(doc)) {
        let assignment = await debaterDoc.ref.collection("MyEvents").doc(id).get();
        newDoc[id] = {...event, ...getPartnerDetails(assignment.data().assignment, debaterDoc.data().uid)};
    }
    debaterDoc.ref.collection("PersonalData").doc("Feedbacks").set(newDoc);
    console.log(debaterDoc.ref.id + " done");
}

async function addSpeakerPointsForDebater(debaterDoc) {
    if (debaterDoc.id === "All_Debaters") {
        console.log("Skipping All_Debaters");
        return;
    }
    let fDoc = await debaterDoc.ref.collection("PersonalData").doc("Feedbacks").get();
    if(!fDoc.exists) {
        console.log(debaterDoc.ref.id + " no feedbacks yet");
        return;
    }
    let doc = fDoc.data();
    if (Object.values(doc)[0] && Object.values(doc)[0]["speaker_points"]) {
        console.log(debaterDoc.ref.id + " already migrated");
        return;
    }
    let update = {};
    Object.keys(doc).forEach(entry => {
        update[entry + ".speaker_points"] = 0;
    });
    debaterDoc.ref.collection("PersonalData").doc("Feedbacks").update(update);
    console.log(debaterDoc.ref.id + " done");
}

export default Migrator;
